import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'

import type { TagsRequest } from '../../types/tags'
const { TAGS_API_URL } = CONSTANT

const createTags = async (createTags: TagsRequest): Promise<any> => {
	const response = await fetchWithAuthorizationHeader(`${TAGS_API_URL}`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			action: 'CREATE'
		},
		body: JSON.stringify(createTags)
	})

	return response.json()
}

export default createTags
